import React from 'react';
import { Container, Typography, Box, Grid2 as Grid } from '@mui/material';
import Footer from "../layout/Footer";

const PoliticaCookies = () => {
  return (
    <>
      {/* Hero Section */}
      <Box className="header-container">
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Grid container size={12} sx={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="h1" component="h1" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center' }}>
              OneService - Política de Cookies
            </Typography>
            <Typography variant="h3" component="h3" gutterBottom sx={{ color: 'white', textAlign: 'center' }}>
              Fecha de última actualización: {new Date().toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}
            </Typography>
          </Grid>
        </Container>
      </Box >

      <Container maxWidth="md" sx={{ py: 6 }}>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            1. ¿Qué son las cookies?
          </Typography>
          <Typography variant="body1" paragraph>
            Las cookies son pequeños archivos de texto que se almacenan en su computadora, teléfono móvil o dispositivo cuando visita el sitio web de OneService.
            En esta Política utilizamos el término "cookies" de manera general para referirnos a tecnologías similares, tales como:<br />
            · Cookies HTTP<br />
            · Cookies Flash<br />
            · Balizas web (web beacons)<br />
            · Píxeles de seguimiento<br />
            · Tecnologías de almacenamiento local
          </Typography>
          <Typography variant="body1" paragraph>
            Estas herramientas no ocupan espacio significativo y pueden eliminarse automáticamente al finalizar su sesión o permanecer almacenadas por un período determinado, dependiendo de su tipo.
            Algunas cookies se eliminan cuando cierra su navegador (cookies de sesión), mientras que otras pueden permanecer durante un plazo definido (cookies persistentes).
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            2. ¿Qué tipos de cookies utiliza OneService?
          </Typography>
          <Typography variant="body1" paragraph>
            OneService utiliza tanto cookies propias (de origen) como cookies de terceros.<br />
            · Cookies propias: Son establecidas directamente por OneService.<br />
            · Cookies de terceros: Son instaladas por proveedores externos que prestan servicios tecnológicos, analíticos o publicitarios.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            3. Cookies esenciales o necesarias
          </Typography>
          <Typography variant="body1" paragraph>
            Son indispensables para el funcionamiento básico de la Plataforma. Permiten, por ejemplo:<br />
            · Mantener la sesión iniciada.<br />
            · Recordar información temporal durante el proceso de contratación.<br />
            · Garantizar seguridad en la navegación.
          </Typography>
          <Typography variant="body1" paragraph>
            Sin estas cookies, el sitio no puede operar correctamente.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            4. Cookies de funcionalidad
          </Typography>
          <Typography variant="body1" paragraph>
            Permiten recordar preferencias del usuario, tales como:<br />
            · Ubicación.<br />
            · Idioma.<br />
            · Configuración personalizada.<br />
            · Información previamente capturada en formularios.
          </Typography>
          <Typography variant="body1" paragraph>
            Su finalidad es mejorar la experiencia y hacer más eficiente el uso del sitio.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            5. Cookies analíticas o de rendimiento
          </Typography>
          <Typography variant="body1" paragraph>
            Nos permiten comprender cómo los usuarios interactúan con la Plataforma, por ejemplo:<br />
            · Páginas más visitadas.<br />
            · Tiempo de navegación.<br />
            · Tasa de abandono.<br />
            · Errores técnicos.
          </Typography>
          <Typography variant="body1" paragraph>
            La información recopilada es agregada y no identifica directamente al usuario. Estas cookies pueden ser instaladas por OneService o por terceros que actúan en nuestro nombre.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            6. Cookies publicitarias y de segmentación
          </Typography>
          <Typography variant="body1" paragraph>
            Estas cookies permiten:<br />
            · Mostrar publicidad relevante.<br />
            · Limitar el número de veces que se muestra un anuncio.<br />
            · Medir la efectividad de campañas publicitarias.<br />
            · Recordar intereses del usuario.
          </Typography>
          <Typography variant="body1" paragraph>
            Algunas de estas cookies pueden ser gestionadas por terceros y podrían reconocer su dispositivo cuando visita otros sitios web. OneService no vende datos personales; cualquier uso publicitario se realiza conforme a la legislación mexicana aplicable.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            7. Cookies de redes sociales e interacción
          </Typography>
          <Typography variant="body1" paragraph>
            Permiten:<br />
            · Compartir contenido en redes sociales.<br />
            · Integrar funcionalidades externas.<br />
            · Registrar interacciones con contenido compartido.
          </Typography>
          <Typography variant="body1" paragraph>
            Estas cookies pueden ser establecidas por plataformas externas cuando el usuario interactúa con dichos servicios.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            8. ¿Por qué utilizamos cookies?
          </Typography>
          <Typography variant="body1" paragraph>
            OneService utiliza cookies para:<br />
            · Garantizar el funcionamiento técnico de la Plataforma.<br />
            · Mejorar la experiencia del usuario.<br />
            · Optimizar el rendimiento del sitio.<br />
            · Analizar patrones de uso.<br />
            · Personalizar contenido y comunicaciones.<br />
            · Fortalecer la seguridad digital.
          </Typography>
          <Typography variant="body1" paragraph>
            El uso de cookies se realiza conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares y demás normativa aplicable en México.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            9. ¿Qué ocurre si no desea aceptar cookies?
          </Typography>
          <Typography variant="body1" paragraph>
            El usuario puede:<br />
            · Configurar su navegador para bloquear o eliminar cookies.<br />
            · Deshabilitar determinadas categorías desde el banner de configuración.<br />
            · Eliminar cookies almacenadas en cualquier momento.
          </Typography>
          <Typography variant="body1" paragraph>
            Debe tener en cuenta que:<br />
            · Bloquear cookies esenciales puede afectar el funcionamiento de la Plataforma.<br />
            · Algunas funcionalidades podrían no estar disponibles.<br />
            · Es posible que deba volver a configurar sus preferencias si elimina las cookies.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            10. Consentimiento
          </Typography>
          <Typography variant="body1" paragraph>
            Al continuar navegando en la Plataforma y aceptar el aviso correspondiente, el usuario consiente el uso de cookies conforme a esta Política. El consentimiento podrá revocarse en cualquier momento mediante la configuración del navegador o herramientas habilitadas en la Plataforma.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            11. Actualizaciones
          </Typography>
          <Typography variant="body1" paragraph>
            OneService podrá modificar esta Política de Cookies en cualquier momento para reflejar cambios tecnológicos, operativos o regulatorios.
          </Typography>
        </Box>

      </Container>
      <Footer />
    </>
  );
};

export default PoliticaCookies;
